import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError, GetListResponse } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { BoxMovement, GetBoxMovementsParams } from "../../transfers.types";
import { requestGetBoxMovements } from "./getBoxMovements.request";

const useGetBoxMovements = (
  requestParams: GetBoxMovementsParams,
  options?: QueryOptions<
    GetListResponse<BoxMovement>,
    ApiServiceError<ApiError>
  >,
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["box-movement-admin", "all", requestParams],
    queryFn: async () => await requestGetBoxMovements(requestParams),
    ...options,
  });

  return { boxMovements: data?.data, meta: data?.meta, ...rest };
};

export default useGetBoxMovements;
